import * as React from "react";
import { forwardRef, memo } from "react";
const SvgArrowUpLine = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "icon/arrow-up-line" }, /* @__PURE__ */ React.createElement("path", { id: "ic", d: "M9.16657 5.21928V13.3337H7.83324V5.21928L4.25727 8.79526L3.31445 7.85246L8.49991 2.66699L13.6854 7.85246L12.7426 8.79526L9.16657 5.21928Z", fill: "white" })));
const ForwardRef = forwardRef(SvgArrowUpLine);
const Memo = memo(ForwardRef);
export default Memo;
